import { loginUser } from '@/api/auth';
import VueCookies from "vue-cookies";
const userStore = {
	namespaced: true,
	state: {
		userId: VueCookies.get("id") || "",
		userGrade: VueCookies.get("userGrade") || "",
		ndbTkn: VueCookies.get("ndbTkn") || "",
	},
	getters: {
		isLogin(state) {
			return state.accessToken !== "";
		},
		getId(state) {
			return state.id;
		},
		getUserGrade(state) {
			return state.userGrade;
		},
		getNdbTkn(state) {
			return state.ndbTkn;
		},
	},
	mutations: {
		SET_ID(state, id) {
			state.userId = id;
		},
		SET_USER_GRADE(state, userGrade) {
			state.userGrade = userGrade;
		},
		SET_NDB_TKN(state, ndbTkn) {
			state.ndbTkn = ndbTkn;
		},
		CLEAR_ALL(state) {
			state.userId = "";
			state.userGrade = "";
			state.ndbTkn = "";
		},
	},
	actions: {
    async LOGIN({ commit }, loginUserData) {
      const { data } = await loginUser(loginUserData);
      commit("SET_ID", data.data.userId);
      commit("SET_USER_GRADE", data.data.userGrade);
      commit("SET_NDB_TKN", data.data.ndbTkn);
      VueCookies.set("userId", data.data.userId);
      VueCookies.set("userGrade", data.data.userGrade);
      VueCookies.set("ndbTkn", data.data.ndbTkn);
    },

		LOGOUT({ commit }) {
			commit("CLEAR_ALL");
      VueCookies.remove("userId");
      VueCookies.remove("userNm");
      VueCookies.remove("userGrade");
      VueCookies.remove("ndbTkn");
      VueCookies.remove("loginDate");
		},

     REFRESH_USER({ commit }, data) {
      commit("SET_NDB_TKN", data.data.ndbTkn);
      VueCookies.set("ndbTkn", data.data.ndbTkn);
    }
	},
};

export default userStore;
